// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRecurringContributionAggregatorRequestDto
 */
export interface IRecurringContributionAggregatorRequestDto {
    /**
     * 
     * @type {number}
     * @memberof IRecurringContributionAggregatorRequestDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof IRecurringContributionAggregatorRequestDto
     */
    frequency_type: IRecurringContributionAggregatorRequestDtoFrequencyTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IRecurringContributionAggregatorRequestDto
     */
    recurring_day_number: number;
    /**
     * 
     * @type {Date}
     * @memberof IRecurringContributionAggregatorRequestDto
     */
    start_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof IRecurringContributionAggregatorRequestDto
     */
    end_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IRecurringContributionAggregatorRequestDto
     */
    status: IRecurringContributionAggregatorRequestDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IRecurringContributionAggregatorRequestDto
     */
    payment_method_id: number;
    /**
     * 
     * @type {Date}
     * @memberof IRecurringContributionAggregatorRequestDto
     */
    notification_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IRecurringContributionAggregatorRequestDto
     */
    next_scheduled_date?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IRecurringContributionAggregatorRequestDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY'
}
/**
* @export
* @enum {string}
*/
export enum IRecurringContributionAggregatorRequestDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    CANCELLED = 'CANCELLED',
    EXPIRED = 'EXPIRED'
}


/**
 * Check if a given object implements the IRecurringContributionAggregatorRequestDto interface.
 */
export function instanceOfIRecurringContributionAggregatorRequestDto(value: object): value is IRecurringContributionAggregatorRequestDto {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('frequency_type' in value) || value['frequency_type'] === undefined) return false;
    if (!('recurring_day_number' in value) || value['recurring_day_number'] === undefined) return false;
    if (!('start_date' in value) || value['start_date'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('payment_method_id' in value) || value['payment_method_id'] === undefined) return false;
    return true;
}

export function IRecurringContributionAggregatorRequestDtoFromJSON(json: any): IRecurringContributionAggregatorRequestDto {
    return IRecurringContributionAggregatorRequestDtoFromJSONTyped(json, false);
}

export function IRecurringContributionAggregatorRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRecurringContributionAggregatorRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'frequency_type': json['frequency_type'],
        'recurring_day_number': json['recurring_day_number'],
        'start_date': (new Date(json['start_date'])),
        'end_date': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'status': json['status'],
        'payment_method_id': json['payment_method_id'],
        'notification_date': json['notification_date'] == null ? undefined : (new Date(json['notification_date'])),
        'next_scheduled_date': json['next_scheduled_date'] == null ? undefined : (new Date(json['next_scheduled_date'])),
    };
}

export function IRecurringContributionAggregatorRequestDtoToJSON(json: any): IRecurringContributionAggregatorRequestDto {
    return IRecurringContributionAggregatorRequestDtoToJSONTyped(json, false);
}

export function IRecurringContributionAggregatorRequestDtoToJSONTyped(value?: IRecurringContributionAggregatorRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'frequency_type': value['frequency_type'],
        'recurring_day_number': value['recurring_day_number'],
        'start_date': ((value['start_date']).toISOString().substring(0,10)),
        'end_date': value['end_date'] == null ? undefined : ((value['end_date']).toISOString().substring(0,10)),
        'status': value['status'],
        'payment_method_id': value['payment_method_id'],
        'notification_date': value['notification_date'] == null ? undefined : ((value['notification_date']).toISOString().substring(0,10)),
        'next_scheduled_date': value['next_scheduled_date'] == null ? undefined : ((value['next_scheduled_date']).toISOString().substring(0,10)),
    };
}

